import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';

import { ACHIEVEMENT_MODAL_KEYS } from '@Services/Editor/Constants';

import { setAchievementChipState, setAchievementModalStateByType } from '@Services/Editor';

import { ReactComponent as AchievementPropertiesSVG } from '@Assets/Svgs/ic_properties_achievement.svg';
import Button from '@Components/Common/Button';
import TX from '@Components/Common/Text';

const AchievementButton = ({ isAchievementChipVisible, processId, choiceId, resultId, newAchievementId }) => {
  const dispatch = useDispatch();
  const achievement = useSelector(({ editor }) => editor.achievements.achievement);

  // const linkedAchievementTitle = achievement[newAchievementId]?.title;
  const linkedAchievementTitle = achievement.find(item => item.id === newAchievementId)?.title;

  const handleAchievementButtonClick = useCallback(() => {
    dispatch(setAchievementModalStateByType({ type: ACHIEVEMENT_MODAL_KEYS.MODAL_VISIBLE }));
    dispatch(setAchievementModalStateByType({ type: ACHIEVEMENT_MODAL_KEYS.USING_CHIP }));
    dispatch(setAchievementChipState({ processId, choiceId, resultId }));
  }, [isAchievementChipVisible, dispatch, processId, choiceId, resultId]);

  if (!isAchievementChipVisible) {
    return null;
  }

  return (
    <Button
      isTextOnly={false}
      backgroundColor="transparent"
      style={{ padding: '6px 10px 6px 6px', height: '28px' }}
      onClick={handleAchievementButtonClick}
    >
      <StyledIconWrapper>
        <AchievementIcon />
      </StyledIconWrapper>

      <AchievementButtonText isBlack={linkedAchievementTitle}>
        {linkedAchievementTitle || '업적 선택...'}
      </AchievementButtonText>
    </Button>
  );
};

AchievementButton.propTypes = {
  isAchievementChipVisible: PropTypes.bool.isRequired,
  processId: PropTypes.number.isRequired,
  choiceId: PropTypes.number.isRequired,
  resultId: PropTypes.number.isRequired,
  newAchievementId: PropTypes.number,
};

AchievementButton.defaultProps = {
  newAchievementId: null,
};

const IconCSS = css`
  width: 16px;
  height: 16px;
`;

const StyledIconWrapper = styled.div`
  ${IconCSS}

  display: flex;
  align-items: center;
  justify-content: center;

  margin-right: 4px;
`;

const AchievementIcon = styled(AchievementPropertiesSVG)`
  fill: #ffe456;
`;

const AchievementButtonText = styled(TX.FootnoteM)`
  color: ${({ isBlack, theme }) => (isBlack ? theme.colors.ui_on_2 : theme.colors.ui_on_4)};
`;

export default React.memo(AchievementButton);
